// The endpoint returns an unknown interface
export function mapDeleteOrganizationEnvironmentResponse(response: unknown): unknown {
  return response;
}
